import { render, staticRenderFns } from "./AttachedResponsibilityToRole.vue?vue&type=template&id=420a15c6"
import script from "./AttachedResponsibilityToRole.vue?vue&type=script&lang=js"
export * from "./AttachedResponsibilityToRole.vue?vue&type=script&lang=js"
import style0 from "./AttachedResponsibilityToRole.vue?vue&type=style&index=0&id=420a15c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports